import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingModal from './components/modals/LoadingModal';
import { gerarPcaDocx } from './utils/relatoriosGlobais';

export default function PcaDocx() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const run = async () => {
      try {
        await gerarPcaDocx(() => {});
      } catch (err) {
        setError(err.message || 'Erro desconhecido');
      } finally {
        setLoading(false);
        setTimeout(() => navigate('/home'), 1000);
      }
    };
    run();
  }, []);

  return (
    <div className="container mt-5">
      <LoadingModal loading={loading} />
      {error && <div className="text-danger">Erro: {error}</div>}
    </div>
  );
}
